import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fc3e348"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-question__title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-question__title__asterisk" }, " *", -1))
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "tw-form-control" }
const _hoisted_5 = ["aria-label", "aria-describedby", "placeholder", "aria-invalid"]
const _hoisted_6 = ["id"]

import { InterviewQuestionResponseModel } from '@/models/QuestionModels'
import { useInterviewStore } from '@/stores/interviewStore'
import { computed, onMounted, ref, watch } from 'vue'
import FlatButton from '@/components/Shared/FlatButton.vue'
import { scrollToElementBottom } from '../scrollToElementBottom';
import TermsOfUse from '@/components/InterviewQuestionary/TermsOfUse.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailQuestion',
  props: {
    question: null
  },
  emits: ['handleAnswerChoose'],
  setup(__props: any, { emit: emits }) {

const props = __props as { question: InterviewQuestionResponseModel };

const EMAIL_REGEXP = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);

const answer = ref<string>('')
const isSubmited = ref<boolean>(false)
const isTermsAccepted = ref<boolean>(false)

const touched = ref(false);




const interviewStore = useInterviewStore()

const nextBtnText = computed(() => interviewStore.getLocalization('InterviewQuestionary.Common.NextQuestionButton'))
const errorMessage = computed(() => interviewStore.questionsAnswerError[props.question.Id])
const isSubmitable = computed(() => {
    validateField()
    return !!answer.value && EMAIL_REGEXP.test(answer.value)
});
const isTermsOfUse = computed(() => interviewStore.isTerms)

const root = ref<HTMLElement | undefined>(undefined);
onMounted(() => {
    isTermsAccepted.value = interviewStore.getCookie('termsOfUse') != null && interviewStore.getCookie('privacyPilicy') != null;
    scrollToElementBottom(root!.value as HTMLElement)
    interviewStore.checkIfIsTerms()
});

function submitQuestion() {
    if (!isSubmitable.value || (interviewStore.isLastQuestion && interviewStore.checkError())) {
        return
    }

    interviewStore.nextQuestion()
    isSubmited.value = true
}

function validateField() {
    if (!answer.value && touched.value) {
        interviewStore.questionsAnswerError[props.question.Id] = interviewStore.getLocalization('Accessability.InterviewQuestionary.EmailField.Empty')
    }else if (!EMAIL_REGEXP.test(answer.value) && touched.value) {
        interviewStore.questionsAnswerError[props.question.Id] = interviewStore.getLocalization('Accessability.InterviewQuestionary.EmailField.Invalid')
    }else{
        interviewStore.questionsAnswerError[props.question.Id] = null
        interviewStore.questionsAnswerError["termsOfUse"] = null
    }
}

function pushAnswer(ans: string | null) {
    if (ans && ans?.length > 0) {
        interviewStore.changeAnswer(props.question.Id, ans)
    }
}

watch(answer, (newValue) => {
    emits('handleAnswerChoose', newValue)
    pushAnswer(newValue)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "tw-question"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(__props.question.Title), 1),
      _hoisted_2
    ]),
    (!!__props.question.Description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "email-question-desc",
          innerHTML: __props.question.Description,
          class: "tw-question__description"
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((answer).value = $event)),
        inputmode: "email",
        type: "email",
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (touched.value = true)),
        "aria-label": __props.question.Label,
        "aria-describedby": _unref(errorMessage) ? 'email-question-error-' + __props.question.Id : 'email-question-desc',
        placeholder: __props.question.Label,
        class: _normalizeClass(["tw-form-control__input", {
                        'tw-form-control__field-error--highlight': touched.value && !_unref(isSubmitable),
                        'tw-form-control__input--error': touched.value && !_unref(isSubmitable)
                    }]),
        name: "email",
        autocomplete: "email",
        "aria-required": true,
        "aria-invalid": touched.value && !_unref(isSubmitable)
      }, null, 42, _hoisted_5), [
        [_vModelText, answer.value]
      ]),
      (_unref(errorMessage))
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "tw-question__error",
            id: 'email-question-error-' + __props.question.Id,
            role: "alert",
            "aria-live": "polite"
          }, _toDisplayString(_unref(errorMessage)), 9, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _createVNode(TermsOfUse, {
      questionId: __props.question.Id
    }, null, 8, ["questionId"]),
    (_unref(isSubmitable) && !isSubmited.value && _unref(isTermsOfUse))
      ? (_openBlock(), _createBlock(FlatButton, {
          key: 1,
          onClick: submitQuestion,
          modelValue: _unref(nextBtnText),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(nextBtnText) ? (nextBtnText).value = $event : null)),
          bgColor: '#2C267A',
          isArrowStyle: true
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})